import React from 'react';
interface DurationInputProps {
  label?: string;
  value: {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
  };
  onChange: (value: {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
  }) => void;
  helperText?: string;
}
export function DurationInput({
  label,
  value,
  onChange,
  helperText
}: DurationInputProps) {
  const handleChange = (field: keyof typeof value, val: string) => {
    const numVal = parseInt(val) || 0;
    onChange({
      ...value,
      [field]: numVal
    });
  };
  return <div className="space-y-2" data-id="element-1171">
      {label && <label className="text-sm font-medium text-gray-700" data-id="element-1172">{label}</label>}
      <div className="flex items-center space-x-2" data-id="element-1173">
        <div className="flex-1" data-id="element-1174">
          <div className="relative rounded-md shadow-sm" data-id="element-1175">
            <input type="number" min="0" value={value.days} onChange={e => handleChange('days', e.target.value)} className="block w-full rounded-md border-gray-300 pl-3 pr-12 focus:border-blue-500 focus:ring-blue-500 sm:text-sm border h-10" data-id="element-1176" />
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3" data-id="element-1177">
              <span className="text-gray-500 sm:text-sm" data-id="element-1178">Days</span>
            </div>
          </div>
        </div>
        <div className="flex-1" data-id="element-1179">
          <div className="relative rounded-md shadow-sm" data-id="element-1180">
            <input type="number" min="0" max="23" value={value.hours} onChange={e => handleChange('hours', e.target.value)} className="block w-full rounded-md border-gray-300 pl-3 pr-12 focus:border-blue-500 focus:ring-blue-500 sm:text-sm border h-10" data-id="element-1181" />
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3" data-id="element-1182">
              <span className="text-gray-500 sm:text-sm" data-id="element-1183">Hrs</span>
            </div>
          </div>
        </div>
        <div className="flex-1" data-id="element-1184">
          <div className="relative rounded-md shadow-sm" data-id="element-1185">
            <input type="number" min="0" max="59" value={value.minutes} onChange={e => handleChange('minutes', e.target.value)} className="block w-full rounded-md border-gray-300 pl-3 pr-12 focus:border-blue-500 focus:ring-blue-500 sm:text-sm border h-10" data-id="element-1186" />
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3" data-id="element-1187">
              <span className="text-gray-500 sm:text-sm" data-id="element-1188">Mins</span>
            </div>
          </div>
        </div>
        <div className="flex-1" data-id="element-1189">
          <div className="relative rounded-md shadow-sm" data-id="element-1190">
            <input type="number" min="0" max="59" value={value.seconds} onChange={e => handleChange('seconds', e.target.value)} className="block w-full rounded-md border-gray-300 pl-3 pr-12 focus:border-blue-500 focus:ring-blue-500 sm:text-sm border h-10" data-id="element-1191" />
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3" data-id="element-1192">
              <span className="text-gray-500 sm:text-sm" data-id="element-1193">Secs</span>
            </div>
          </div>
        </div>
      </div>
      {helperText && <p className="text-xs text-gray-500" data-id="element-1194">{helperText}</p>}
    </div>;
}